export default __webpack_public_path__ + "static/assets/63c8fb90b1eb30d8faf75ee660657355.gif";